if (!window.PredictiveSearchDefined) {
	window.PredictiveSearchDefined = true;
	
	class PredictiveSearch extends HTMLElement {
		constructor() {
			super();

			this.input = this.querySelector('input[type="search"]');
			this.predictiveSearchResults = this.querySelector('#predictive-search');

			this.input.addEventListener(
				'input',
				this.debounce((event) => {
					//MOON MOON
					if (this.input.value.length > 0) {
						document.querySelector('#mmSearchClear > svg').style.opacity = '1';
					} else {
						document.querySelector('#mmSearchClear > svg').style.opacity = '0';
					}
					//MOON MOON
					this.onChange(event);
				}, 300).bind(this)
			);
		}

		onChange() {
			const searchTerm = this.input.value.trim();

			if (!searchTerm.length) {
				this.close();
				return;
			}

			this.getSearchResults(searchTerm);
		}

		getSearchResults(searchTerm) {
			fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
				.then((response) => {
					console.log('response :', response);
					if (!response.ok) {
						var error = new Error(response.status);
						this.close();
						throw error;
					}

					return response.text();
				})
				.then((text) => {
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
					this.predictiveSearchResults.innerHTML = resultsMarkup;
					this.open();
					searchSplideProducts();
				})
				.catch((error) => {
					this.close();
					throw error;
				});
		}

		open() {
			this.predictiveSearchResults.style.display = 'block';
			if (window.innerWidth > 768) {
				document.querySelector('.mm-header-search-container').style.height = '100dvh';
			}
		}

		close() {
			this.predictiveSearchResults.style.display = 'none';
			if (window.innerWidth > 768) {
				document.querySelector('.mm-header-search-container').style.height = 'auto';
			}
			// Le scroll sera géré par mmHideSearch, donc on ne le gère pas ici
			// pour éviter les conflits
		}

		debounce(fn, wait) {
			let t;
			return (...args) => {
				clearTimeout(t);
				t = setTimeout(() => fn.apply(this, args), wait);
			};
		}
	}

	customElements.define('predictive-search', PredictiveSearch);
}
